import React from 'react'

const CreateCustomers = () => {
  return (
    <div>CreateCustomers</div>
  )
}

export default CreateCustomers